import { useState, useRef } from 'react';
import { compactArray } from '@mews/fp';
import { Typography, Stack, StackItem, Position, Link } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { Popover } from '@mews/b2b-ui';
import { LoyaltyMembership } from '@mews-commander/data-access';
import { LoyaltyMembershipInfo } from './LoyaltyMembershipInfo';

interface CompactedClassificationPopoverProps {
    elements: React.ReactNode[];
}
const CompactedClassificationPopover = ({ elements }: CompactedClassificationPopoverProps) => {
    const elementRef = useRef<HTMLAnchorElement | null>(null);
    const [active, setActive] = useState(false);
    return (
        <>
            <Link onClick={() => setActive(true)} ref={elementRef} inherit>
                {UnicodeEntity.PlusSign}
                {elements.length}
            </Link>
            <Popover
                position={Position.Top}
                active={active}
                anchorElement={elementRef.current}
                title={<LocalizedText textKey={TextKey.Classifications} />}
                onClose={() => setActive(false)}
            >
                <Typography textStyle="bodySmall" variant="secondary" as="div">
                    <Stack vertical spacing="100" itemAlignment="start">
                        {elements}
                    </Stack>
                </Typography>
            </Popover>
        </>
    );
};
interface CompactedClassificationProps {
    loyaltyMembership?: LoyaltyMembership | null;
    classifications: React.ReactNode[];
}
export const CompactedCustomerClassification = ({
    loyaltyMembership,
    classifications,
}: CompactedClassificationProps) => {
    const ordering = [
        loyaltyMembership ? <LoyaltyMembershipInfo loyaltyMembership={loyaltyMembership} /> : null,
        ...classifications,
    ];

    const [shown, ...compacted] = compactArray(ordering);

    return shown ? (
        <Typography textStyle="bodySmall" variant="secondary" data-test-smart-detail-reservation-actor-label as="div">
            <Stack spacing="50">
                <StackItem minWidth="0">{shown}</StackItem>
                {compacted.length ? <CompactedClassificationPopover elements={compacted} /> : null}
            </Stack>
        </Typography>
    ) : null;
};
